import React from "react";
import MaterialTable from "material-table";
import CircularProgress from "@material-ui/core/CircularProgress";
import { tableIcons } from "../../shared/TableIcons";
import exportPDF from "../../services/exportPDF";
import exportCSV from "../../services/exportCSV";

function AllAlerts(props) {
  return (
    <div>
      {props.data !== "" && props.data !== [] ? (
        <MaterialTable
          icons={tableIcons}
          title="Όλες οι Ειδοποιήσεις"
          columns={props.col}
          data={props.data}
          actions={[]}
          localization={{
            body: {
              emptyDataSourceMessage: "Δεν υπάρχουν Εγγραφές",
            },
            toolbar: {
              addRemoveColumns: "Προσθέστε ή αφαιρέστε κολώνες",
              showColumnsTitle: "Δείξτε κολώνες",
              addTooltip: "Προσθήκη",
              searchTooltip: "Αναζήτηση",
              searchPlaceholder: "Αναζήτηση",
              exportTitle: "Εξαγωγή",
              exportCSVName: "Εξαγωγή σε CSV",
              exportPDFName: "Εξαγωγή σε PDF",
            },

            pagination: {
              firstTooltip: "Πρώτη Σελίδα",
              lastTooltip: "Τελευταία Σελίδα",
              previousTooltip: "Προηγούμενη Σελίδα",
              nextTooltip: "Επόμενη Σελίδα",
              labelDisplayedRows: "{from}-{to} από {count}",
              labelRowsSelect: "Εγγραφές ανά Σελίδα",
            },
            grouping: {
              placeholder: "Σύρετε για να ομαδοποιήσετε",
              groupedBy: "Σύρετε για να ομαδοποιήσετε",
            },
            header: {
              actions: "Ενέργειες",
            },
          }}
          options={{
            exportPdf: (columns, data) => {
              exportPDF(columns, data);
            },
            exportCsv: (columns, data) => {
              exportCSV(columns, data);
            },

            searchFieldAlignment: "left",
            columnsButton: true,
            exportButton: true,
            grouping: true,
            sorting: true,
            filtering: true,
            exportAllData: true,
          }}
        />
      ) : (
        <CircularProgress></CircularProgress>
      )}
    </div>
  );
}

export default AllAlerts;
